const orgSensorColumns = [
  {
    prop: 'barcode',
    label: 'Barcode',
    sortable: false,
    width: 150
  },
  {
    prop: 'pestTypeName',
    label: 'Pest Type',
    sortable: false,
    width: 150
  },
  {
    prop: 'currentStatus',
    label: 'Status',
    sortable: false,
    width: 100
  },
  {
    prop: 'formattedBattery',
    label: 'Battery',
    sortable: false,
    width: 100
  },
];

const orgSensorOptions = {
  'default-sort': {
    prop: 'createdOn',
    order: 'desc'
  },
  limit: 10,
  searchParams: {
    default: 'barcode',
    params: [
      {
        label: 'Barcode',
        value: 'barcode',
      }
    ]
  }
};

export { orgSensorColumns, orgSensorOptions }
